import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

/** One item per Jira Cloud site, keyed by its host (`acme.atlassian.net`).
 *
 * P0 files issues on the site as one Atlassian service account, signed in
 * with its OAuth 2.0 credential: `clientId`, and `clientSecret`, which the
 * install framework encrypts into P0's secrets store. The tracker files every
 * issue in one project, so a tenant has one site.
 *
 * Modelled on Tailscale's `iam-write` component, which takes an OAuth client
 * the same way.
 */
export const JiraTrackerComponents = InstallSpec({
  site: ItemComponent({
    label: "Jira site",
    description: "The Jira Cloud site P0 files findings on",
    type: "string",
    maturity: "preview",
    // No item validator, though the id has to be a site's host
    // (`isSiteHost`). The install framework runs an item validator first, and
    // its error repeats the whole request, which holds the client secret. So
    // the site's assembler checks the id itself.
    schema: {
      clientId: Element({
        label: "Client ID",
        description:
          "The client ID of the Atlassian service account's OAuth 2.0 credential",
        type: "string",
      }),
      clientSecret: Element({
        label: "Client secret",
        description:
          "The client secret of the Atlassian service account's OAuth 2.0 credential",
        type: "encrypted",
      }),
      cloudId: Element({
        label: "Cloud ID",
        description:
          "The site's Atlassian cloud ID, which P0 finds when the site is validated",
        type: "generated",
      }),
    },
  }),
});
